import { useState, useEffect } from "react";
import { useReduxStore } from "../../hooks/useReduxStore";
import { useLocation } from "react-router-dom";
import { updateHome } from "../../store/Reducers/homeReducer";
import { getItemAccessType } from "../../helper/accessTypeHelper";

const useCheckout = () => {
  const [modalType, setModalType] = useState(null);
  const location = useLocation();
  const { dispatch, getState } = useReduxStore();
  const { userData } = getState("AUTH");
  const { itemDetail } = getState("Item");
  const { selectedPackage } = getState("Home");

  // Strict subscription resolution: ONLY active when explicitly requested via navigation state
  const state = location?.state || {};
  const isSubscription = Boolean(
    state.isSubscription === true && state.package
  );
  const activePackage = isSubscription ? state.package : null;

  // Resolve target media product item (One-Time Buy or PPV)
  const productItem = !isSubscription
    ? state.item || (state.id && !state.package ? state : null) || itemDetail || {}
    : null;

  const checkoutData = isSubscription
    ? {
        ...activePackage,
        isSubscription: true,
        price: activePackage?.price || 0,
      }
    : {
        ...productItem,
        isSubscription: false,
        price: productItem?.price || 0,
      };

  const access = getItemAccessType(checkoutData);

  // Service charges apply exclusively to single items (never to subscriptions)
  const serviceCharges = isSubscription
    ? 0
    : Number(
        productItem?.service_charges ||
        productItem?.category?.[0]?.service_charges ||
        0
      );

  const subTotal = Number(checkoutData?.price) || 0;
  const discountPrice = 0;
  const total = Number((subTotal - discountPrice + serviceCharges).toFixed(2));
  const handelModalType = (type) => setModalType(type);

  // Clear any stale selectedPackage from Redux when purchasing an item
  useEffect(() => {
    if (!isSubscription && selectedPackage) {
      dispatch(updateHome({ selectedPackage: null }));
    }
  }, [isSubscription, selectedPackage, dispatch]);

  return {
    itemDetail: checkoutData,
    subTotal,
    discountPrice,
    serviceCharges,
    total,
    modalType,
    handelModalType,
    userData,
    isSubscription,
    activePackage,
    access,
    hasValidCheckoutItem: Boolean(
      isSubscription ? activePackage?.id : productItem?.id
    ),
  };
};

export default useCheckout;

